import { render, staticRenderFns } from "./InvoiceHome.vue?vue&type=template&id=0b182724&"
import script from "./InvoiceHome.vue?vue&type=script&lang=ts&"
export * from "./InvoiceHome.vue?vue&type=script&lang=ts&"
import style0 from "./Invoice.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports